import * as ng from 'angular';

ng.module('e360')
   .directive('nvLowercase', lowercaseDirective);

export function lowercaseDirective():ng.IDirective {
   return {
      restrict: 'A',
      require: 'ngModel',
      link: lowercaseDirectiveLinkFn
   };
}

function lowercaseDirectiveLinkFn(
   scope:ng.IScope,
   element:JQuery,
   attrs:ng.IAttributes,
   ngModel:ng.INgModelController)
{
   ngModel.$parsers.push((value:string) => {
      let transformedInput = value ? value.toLowerCase() : value;

      if (transformedInput != value) {
         ngModel.$setViewValue(transformedInput);
         ngModel.$render();
      }

      return transformedInput;
   });
}
